export type ImageLibraryModel = {
  cache_key: number,
  id: number,
  cover_image: {
    thumb_url: string,
  },
  cover_image_id?: number,
  hidden: boolean,
  image_count?: number,
  owner_id?: number,
  owner_type?: string,
  title: string,
}

export type ImageLibraryRequestOptions = {}

const state = {
  id: null,
  title: '',
  owner_id: null,
  owner_type: '',
}

export const requiredFields = [
  { key: 'title' },
  { key: 'owner_id' },
  { key: 'owner_type' },
]

export default state
